import { ActionIcon, Box, Group, SegmentedControl, Title, Tooltip } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

export type FieldEditorViewMode = 'visual' | 'toml';

export interface FieldEditorHeaderProps {
  formTitle: string;
  viewMode: FieldEditorViewMode;
  onViewModeChange: (mode: FieldEditorViewMode) => void;
  onBack: () => void;
}

export function FieldEditorHeader({
  formTitle,
  viewMode,
  onViewModeChange,
  onBack,
}: FieldEditorHeaderProps) {
  const { t } = useTranslation();

  return (
    <Box
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 5,
        height: 64,
        background: 'var(--mantine-color-body)',
        borderBottom: '1px solid var(--mantine-color-gray-3)',
      }}
      px="md"
    >
      <Group justify="space-between" wrap="nowrap" h="100%">
        <Group gap="sm" wrap="nowrap" style={{ minWidth: 0 }}>
          <Tooltip label={t('fieldEditor.back')} position="bottom">
            <ActionIcon
              variant="subtle"
              size="lg"
              onClick={onBack}
              aria-label={t('fieldEditor.back')}
            >
              <IconArrowLeft size={20} />
            </ActionIcon>
          </Tooltip>
          <Title
            order={3}
            style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
          >
            {formTitle || t('fieldEditor.title')}
          </Title>
        </Group>
        <SegmentedControl
          value={viewMode}
          onChange={(v) => onViewModeChange(v as FieldEditorViewMode)}
          data={[
            { label: t('fieldEditor.viewVisual'), value: 'visual' },
            { label: t('fieldEditor.viewToml'), value: 'toml' },
          ]}
        />
      </Group>
    </Box>
  );
}
